module.exports = __webpack_public_path__ + "img/shopping-retail.c8cbffe3.jpg";